import { render } from "./index.vue?vue&type=template&id=4aecde04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4aecde04&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aecde04"],['__file',"src/views/setting/menuManagement/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aecde04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aecde04', __exports__)) {
    console.log('reload')
    api.reload('4aecde04', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4aecde04&scoped=true", () => {
    console.log('re-render')
    api.rerender('4aecde04', render)
  })

}


export default __exports__